module.exports = __webpack_public_path__ + "static/media/mastercard.da14141f.svg";